import React from "react";
import { Button } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import "./AboutSection.css";

export default function AboutSection() {

  const message = `Hi Vivaha Sangamam, I want to know more about your services!`;
    const whatsappLink = `https://wa.me/919876543210?text=${encodeURIComponent(message)}`;

  return (
    <div className="about-wrapper">
      <h1 style={{ textAlign: 'center', fontFamily: "quicksand", color: "#BF0603", marginBottom: "60px" }}>About Vivaha Sangamam</h1>
      <div className="about-container">

        {/* LEFT TEXT */}
        <div className="about-left">
          <h2 className="about-title">
            The Most Trusted Platform for Your Perfect Match
          </h2>

          <p className="about-desc">
            Vivaha Sangamam has helped thousands of families connect with their
            perfect life partner. We believe marriage is not just about two people
            but two families coming together. With our advanced matchmaking support,
            we help you find matches that suit your community, preferences, and values.
          </p>

          <p className="about-highlight">
            Thousands of happy couples have found their match through Vivaha Sangamam.
          </p>

          <Button
            variant="contained"
            size="large"
            startIcon={<WhatsAppIcon />}
            sx={{
              mt: 2,
              width: "fit-content",
              backgroundColor: "#f35b04",
              fontWeight: 700,
              "&:hover": { backgroundColor: "#d04c00ff" },
            }}
            onClick={() => window.open(whatsappLink, "_blank")}
          >
            Register Now
          </Button>        
          </div>
        {/* RIGHT IMAGE */}
        <div className="about-right">
          <img src="https://mysticstudios.in/wp-content/uploads/2017/09/Raam-Dheepitha-16.jpg" alt="Couple" className="about-img" />
        </div>

      </div>

    </div>
  );
}
